// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "webpacked-" + chunkId + "-" + "ffb9a48ee4a34e42" + ".css";
};